module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19snv0E/tc-custom/9781614237693.jpg?1737806199929",
      "alt": "This image is the cover for the book History of the Boston Braves"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("History of the Boston Braves\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The story of the beloved baseball team that kept the city cheering through the Great Depression and two world wars—includes photos.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" For those lucky enough to have passed through the turnstiles of Braves Field, the Boston Braves will forever live in the corridors of their collective memory. Baseball legend Babe Ruth finished his career on the historic diamond at Braves Field, while Hall of Famer Eddie Mathews was just getting started. When the franchise moved the team to Milwaukee in 1953, the Boston Braves helped usher in the modern age of Major League Baseball."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Travel back to the Wig-Wam with author William J. Craig, to a time when players arrived at the ballpark by trolley car and a seat in the bleachers cost sixty cents. From the astounding 1948 pennant season to the final inning, Craig pays tribute to a team that Boston fans will never forget.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William J. Craig\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William J. Craig has served in the U.S. Army and U.S. Air Force. He graduated from Gordon College with a B.A. in history and currently resides with his wife and children in Revere, Massachusetts where he works as an author and speaker.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0